import { render } from "./PlayoutScheduleTab.vue?vue&type=template&id=04818acf"
import script from "./PlayoutScheduleTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutScheduleTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutScheduleTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04818acf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04818acf', __exports__)) {
    api.reload('04818acf', __exports__)
  }
  
  module.hot.accept("./PlayoutScheduleTab.vue?vue&type=template&id=04818acf", () => {
    api.rerender('04818acf', render)
  })

}


export default __exports__